import { useContext, useMemo } from 'react';
import wNumb from 'wnumb';

import { ContentPanel, EtfLabel } from 'shared/ui-kit';
import { ContentPanelTable, ContentPanelInteraction, LinkButton, ContentPanelTablePropsColumn, ContentPanelTablePropsColumnDefaultSorting, ContentPanelTablePropsColumnSortType } from 'shared/ui-kit';

import { IEtfCorrelationBackend } from 'api/correlations';

import styles from './table.module.scss';
import moment from 'moment';
import { decodeSiteResolutionValue, SiteResolutionContext } from 'shared/mechanics/site-resolution';

const numberFormat = wNumb({ decimals: 2 }).to;
const percentFormat = wNumb({ decimals: 2, suffix: '%' }).to;

export interface EftCorrelationPageTableProps {
	ticker: string;
	correlations: IEtfCorrelationBackend[];
	className?: string;
}
export const EftCorrelationPageTable = (props: EftCorrelationPageTableProps) => {
	const desktopColumns: ContentPanelTablePropsColumn<IEtfCorrelationBackend>[] = useMemo(
		() => [
			{ id: 'ticker', title: "Тикер", getValue: entry => entry.ticker, renderCell: entry => <EtfLabel ticker={entry.ticker} allowNavigation />, cellClassName: styles.column_ticker },
			{ id: 'correlation', title: "Корреляция", getValue: entry => entry.correlation, renderCell: entry => entry.correlation == null ? '' : numberFormat(entry.correlation), cellClassName: styles.column_number, defaultSorting: ContentPanelTablePropsColumnDefaultSorting.DESC, sortType: ContentPanelTablePropsColumnSortType.BASIC },
			{ id: 'similarity', title: "Схожесть", getValue: entry => entry.similarity, renderCell: entry => entry.similarity == null ? '' : percentFormat(entry.similarity * 100), cellClassName: styles.column_percent, sortType: ContentPanelTablePropsColumnSortType.BASIC },
			{ id: 'density', title: "Совпадений", getValue: entry => entry.density, renderCell: entry => entry.density == null ? '' : percentFormat(entry.density * 100), cellClassName: styles.column_percent, sortType: ContentPanelTablePropsColumnSortType.BASIC },
			{ id: 'region', title: "Регион", getValue: entry => entry.region, cellClassName: styles.column_text },
			{ id: 'assetClass', title: "Категория актива", getValue: entry => entry.assetClass, cellClassName: styles.column_text },

			{ id: 'firstDate', title: "Старт сравнения", getValue: entry => moment(entry.firstDate).format('D MMM YYYY'), cellClassName: styles.column_text },

			{ id: 'otherTicker', title: "Сравнение", getValue: entry => entry.ticker, renderCell: entry => <a href={`/etf/report/${props.ticker}?options=vs=${entry.ticker}`}><i className="fa fa-chart-line" />Сравнить</a>, cellClassName: styles.column_report },
		],
		[]);
	const mobileColumns: ContentPanelTablePropsColumn<IEtfCorrelationBackend>[] = useMemo(
		() => [
			{ id: 'ticker', title: "Тикер", getValue: entry => entry.ticker, renderCell: entry => <EtfLabel ticker={entry.ticker} allowNavigation />, cellClassName: styles.column_ticker },
			{ id: 'correlation', title: "Корреляция", getValue: entry => entry.correlation, renderCell: entry => entry.correlation == null ? '' : numberFormat(entry.correlation), cellClassName: styles.column_number, defaultSorting: ContentPanelTablePropsColumnDefaultSorting.DESC, sortType: ContentPanelTablePropsColumnSortType.BASIC },
			{ id: 'similarity', title: "Схожесть", getValue: entry => entry.similarity, renderCell: entry => entry.similarity == null ? '' : percentFormat(entry.similarity * 100), cellClassName: styles.column_percent, sortType: ContentPanelTablePropsColumnSortType.BASIC },
			{ id: 'region', title: "Регион", getValue: entry => entry.region, cellClassName: styles.column_text },
			{ id: 'otherTicker', title: "", getValue: entry => entry.ticker, renderCell: entry => <a href={`/etf/report/${props.ticker}?options=vs=${entry.ticker}`}><i className="fa fa-chart-line" /></a>, cellClassName: styles.column_report },
		],
		[]);

	const siteResolution = useContext(SiteResolutionContext);
	const columns = decodeSiteResolutionValue(siteResolution, desktopColumns, mobileColumns);

	return (
		<ContentPanel title="Корреляции с другими фондами" className={props.className}>
			<ContentPanelInteraction>
			<p>
				<LinkButton
					title="Матрица корреляций"
					href={`/map/correlation?etf=${props.ticker}`}
					rel="nofollow"
					target="_blank"
					iconClass="fa fa-chart-line" />
				</p>
			</ContentPanelInteraction>
			<ContentPanelTable columns={columns} rows={props.correlations} fullWidth sortable />
		</ContentPanel>
	);
}